import { User } from './../models/user';
import { Injectable } from '@angular/core';
 
@Injectable()
export class GlobalVars {
  
  public repositori: String;
  public user: User;
  public currentPeriod: number = new Date().getFullYear();

  constructor() {
    this.user = new User();
  }
}

export function dynamicSort(property) {
  var sortOrder = 1;
  if(property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a,b) {
    let firstElement = a[property];
    let secondElement = b[property];

    var result = (firstElement < secondElement) ? -1 : (firstElement > secondElement) ? 1 : 0;
    return result * sortOrder;
  }
}


// WEBPACK FOOTER //
// ./src/app/app.environment.ts